<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img alt="" src="images/detail-yunshu.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>阳光物流行业雇主险（限广东企业）</h2>

					<p>
						① 3人起保，支持线上随时替换，替换率不限
						<br />
						② 最高保额120万，社保用药、误工费、猝死有保障
						<br />
						③ 误工费无免赔，100元/人/天，每次90天，累计180天
						<br />
						④ 医疗费0免赔，医保范围内100%赔付
						<br />
						⑤ 扩展24小时个人意外
						<br />
					</p>

					<!--          <div style="margin: 15px 0">-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 灵活投保，可选1-3月方案，适用临时用工<br>-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 人性关怀，扩展24小时意外，非工作意外也保障<br>-->
					<!--                        <i class="el-icon-success" style="color: #409EFF;font-size: 18px"></i> 保障充足，100/120万方案可选，保障覆盖全面<br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 存在安全带免赔特约</span><br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 不含第三者赔偿责任</span><br>-->
					<!--            <i class="el-icon-error" style="color: red;font-size: 18px"></i>-->
					<!--            <span style="color: red"> 不支持人员批增和替换</span>-->
					<!--          </div>-->
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud
						ref="crud"
						:cell-style="onCellStyle"
						:data="dataPlan"
						:option="optionPlan"
						:span-method="spanMethodPlan"></avue-crud>
				</el-card>

				<el-card header="赔付标准">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							社保用药范围100%赔付，伤残等级对应赔付比例请查看附表
						</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionBenefit">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
			</el-tab-pane>
			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="{question = '', answer = ''} in dataQA" :key="question">
								<div>
									<span
										style="
											width: 20px;
											text-align: center;
											background-color: MediumPurple;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										Q
									</span>
									<span style="font-weight: bold">{{ question }}</span>
								</div>
								<div style="display: flex; margin-top: 12px">
									<span
										style="
											width: 20px;
											height: 28px;
											background-color: MediumSeaGreen;
											color: white;
											padding: 4px;
											border-radius: 4px;
											margin-right: 8px;
										">
										A
									</span>

									<div v-if="question === '中途是否可以加人？新增人员如何收费？'" style="display: inline-block">
										中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。
										<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
											<tr style="text-align: center">
												<th>批增收费比例</th>
												<th v-for="(item, index) in 12" :key="index">{{ item }}个月</th>
											</tr>
											<tr style="text-align: center">
												<td>支付比例</td>
												<td v-for="item in questionDataRate">{{ item }}</td>
											</tr>
										</table>
									</div>

									<span v-else style="white-space: pre-wrap">{{ answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<div style="line-height: 26px; white-space: pre-line">
							<h3 style="display: flex; justify-content: center">投保须知及重要事项告知</h3>
							<div style="line-height: 32px; white-space: pre-line">
								1、本保险适用以下保险条款： 2、本保险由阳光财产保险股份有限公司承保，
								<span class="red-bold">仅限承保营业执照注册地址在广东的企业和组织</span>
								。 3、投保要求：企业名称
								<span class="red-bold">不含“装卸”、“搬运”</span>
								。
								4、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。
								5、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；
								<span class="red-bold">
									故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；
								</span>
								因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。
								6、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
								7、本保险根据投保单位的需求提供电子发票或纸质专票。 8、本保险由博维保险经纪有限公司面向
								<span class="red-bold">广东省内销售并提供服务</span>
								。 9、
								<span class="red-bold">
									鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。保单可批增人员（不足1个月的按1个月收费）；在保单生效后申请退保或批减在保人员的，可退保费为0。
								</span>
								10、中途可以增加保障人员。
								<span class="red-bold">
									保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。
								</span>
								<table border="1" cellpadding="0" ellspacing="0" style="margin: 15px" width="100%">
									<tr style="text-align: center">
										<th>批增收费比例</th>
										<th v-for="item in 12">{{ item }}个月</th>
									</tr>
									<tr style="text-align: center">
										<td>支付比例</td>
										<td v-for="item in questionDataRate">{{ item }}</td>
									</tr>
								</table>
								11、
								<span class="red-bold">
									如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。
								</span>
								12、
								<span class="red-bold">
									本保单不承保以下职业：外卖配送员、快递配送员、平台骑手、平台跑腿人员，如作业内容含有保险人不承保的职业类别工作内容，保险人不承担任何赔偿责任。
								</span>
							</div>
							<el-divider></el-divider>
							<h3>特别约定</h3>
							<div>
								<h4>1、保障期限：</h4>
								自所投保雇主责任保险生效日起，保险期限为一年。
								<h4>2、特别特约：</h4>
								（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人
								<span class="red-bold">超过72小时才报案</span>
								，则保险人对按保单约定的应承担的保险责任，
								<span class="red-bold">免赔50%。</span>
								如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。
								（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。
								（3）鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。保单可批增人员（不足1个月的按1个月收费）；
								<span class="red-bold">在保单生效后申请退保或批减在保人员的，可退保费为0。</span>
								（4）
								<span class="red-bold">
									如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。
								</span>
								（5）
								<span class="red-bold">
									（可选）本保单不承保货车司机和随车人员参与装卸货物有关工作发生的工伤和意外伤害的赔偿责任。
								</span>
								（6）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准，每次事故医疗费用超过人民币0元部分按100%的比例赔付。
								（7）
								<span class="red-bold">
									被保险人从业人员从事高空（高处）作业时，必须按照国家相关安全管理规定（包括但不限于必须佩戴安全绳、安全带或者安装防护网等安全设施设备）执行；从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），
								</span>
								否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，
								<span class="red-bold">免赔25%。</span>
								（8）本保单承保法律费用责任，累计赔偿限额为RMB10万元，每次事故赔偿限额为RMB10万元。
								（9）被保险人从业人员遭受伤害时，
								<span class="red-bold">
									实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，免赔20%。如实际工作是装卸工或货车司乘人员投保了文员、仓管工种，保险人不承担任何赔偿责任。
								</span>
								（10）在工作时间和工作岗位，
								<span class="red-bold">
									突发疾病死亡或者在48小时之内经抢救无效死亡，保险人承担赔偿责任，每人最高赔偿限额=每人身故赔偿限额*20%。
								</span>
								（11）本保单伤残赔偿金：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级而支付相应赔偿金。相应的赔偿限额为该伤残等级所对应的下列“伤残等级赔偿限额比例表”的比例乘以每人死亡赔偿限额所得金额。本保单适用伤残赔付比例按：一级伤残100％，二级伤残80％，三级伤残70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，
								<span class="red-bold">八级伤残20％，九级伤残10％，十级伤残5％。</span>
								（12）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GA/T1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。
								<span class="red-bold">被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付。</span>
								（13）
								<span class="red-bold">本保单指定就诊医院为大陆境内二级及以上公立医院。</span>
								如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。
								（14）本保单附加24小时意外险特别扩展B（2022版）条款，扩展承保被保险人雇员在全天24小时内因意外事故而导致的死亡赔偿金、伤残赔偿金(或自伤残发生之日起在180日内发生死亡)以及因此而引起的意外医药费用（社保范围内用药）。其中，伤残鉴定标准按照《人身保险伤残评定标准（行业标准）》，伤残赔付比例按：一级伤残100％，二级伤残80％，三级伤残70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，
								<span class="red-bold">
									八级伤残20％，九级伤残10％，十级伤残5％。24小时意外险死亡伤残责任与雇主工伤死亡伤残责任共用限额，每人最高不超过保单列明的雇主工伤死亡伤残责任限额的50%；24小时意外险医疗责任与雇主工伤医疗责任共用限额，每人最高不超过保单列明的工伤医疗责任限额。
								</span>
								（15）本特别约定与主条款内容相悖之处，以本特约为准；未尽之处，以主条款为准。
							</div>
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {
	optionBenefit,
	optionPlanXsmYunShu,
	optionPremium,
	optionShortPeriodRate,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product7Details',
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionPlanXsmYunShu,
			optionPremium: optionPremium,
			optionBenefit: optionBenefit,
			optionShortPeriodRate: optionShortPeriodRate,
			dataPlan: [
				{
					plan0: '保障项目',
					plan1: '',
					plan2: '方案一',
					plan3: '方案二',
					plan4: '方案三',
				},
				{
					plan0: '身故/伤残',
					plan1: '',
					plan2: '80万',
					plan3: '100万',
					plan4: '120万',
				},
				{
					plan0: '医疗费用',
					plan1: '',
					plan2: '8万',
					plan3: '10万',
					plan4: '20万',
				},
				{
					plan0: '误工费用',
					plan1: '',
					plan2: '100元/天/人，每次90天，累计180天为限',
					plan3: '',
					plan4: '',
				},
				{
					plan0: '法律费用',
					plan1: '',
					plan2: '每次/累计赔偿限额10万',
					plan3: '',
					plan4: '',
				},
				{
					plan0: '猝死限额',
					plan1: '',
					plan2: '身故/伤残限额的20%',
					plan3: '',
					plan4: '',
				},
				{
					plan0: '保费（不含24小时）',
					plan1: '文员、仓管',
					plan2: '500',
					plan3: '600',
					plan4: '700',
				},
				{
					plan0: '保费（不含24小时）',
					plan1: '装卸工、司机、随车人员',
					plan2: '1100',
					plan3: '1300',
					plan4: '1600',
				},
				{
					plan0: '保费（不含24小时）',
					plan1: '货车司机、随车人员\n' + '（不参与装卸，加选特约5）',
					plan2: '1100',
					plan3: '1300',
					plan4: '1600',
				},
				{
					plan0: '保费（不含24小时）',
					plan1: '货车司机、随车人员\n' + '（参与装卸）',
					plan2: '1375',
					plan3: '1625',
					plan4: '2000',
				},

				{
					plan0: '保费（含24小时）',
					plan1: '文员、仓管',
					plan2: '700',
					plan3: '800',
					plan4: '900',
				},
				{
					plan0: '保费（含24小时）',
					plan1: '装卸工、司机、随车人员',
					plan2: '1300',
					plan3: '1600',
					plan4: '1800',
				},
				{
					plan0: '保费（含24小时）',
					plan1: '货车司机、随车人员\n' + '（不参与装卸，加选特约5）',
					plan2: '1300',
					plan3: '1600',
					plan4: '1800',
				},
				{
					plan0: '保费（含24小时）',
					plan1: '货车司机、随车人员\n' + '（参与装卸）',
					plan2: '1575',
					plan3: '1925',
					plan4: '2200',
				},
				{
					plan0: '保障期限',
					plan1: '',
					plan2: '一年',
					plan3: '',
					plan4: '',
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level10: '5%',
					level9: '10%',
					level8: '20%',
					level7: '30%',
					level6: '40%',
					level5: '50%',
					level4: '60%',
					level3: '70%',
					level2: '80%',
					level1: '100%',
				},
			],
			questionDataRate: ['10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer: '本产品由阳光财产保险股份有限公司承保。',
				},
				{
					question: '广东新市民保（交通运输行业）的保险责任是什么？',
					answer:
						'在保险期间内，被保险人的雇员在中华人民共和国境内因发生下列情形之一而导致伤残或死亡，依照中华人民共和国法律（不包括港、澳、台地区法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同的约定负责赔偿： \n' +
						'（一）在工作时间和工作场所内，因工作原因遭受意外事故的； \n' +
						'（二）工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作而遭受意外事故的； \n' +
						'（三）在工作时间和工作场所内，因履行工作职责遭受暴力等意外伤害的； \n' +
						'（四）患职业病的； \n' +
						'（五）因工外出期间，由于工作原因遭受意外事故或者发生意外导致下落不明的； \n' +
						'（六）在上下班途中，受到非本人主要责任的交通事故或者城市轨道交通、客运轮渡、火车事故伤害的； \n' +
						'（七）在工作时间和工作岗位，突发疾病死亡或者在 48 小时之内经抢救无效死亡的； \n' +
						'（八）在抢险救灾等维护国家利益、公共利益活动中遭受意外事故的； \n' +
						'（九）原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到用人单位后旧伤复发的； \n' +
						'（十）法律、行政法规规定应当认定为工伤的其他情形。\n' +
						'保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼的，对应由被保 \n' +
						'险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的费用（以下简称“法律费用”），保险人按照本保险合同约定也负责赔偿。',
				},
				{
					question: '哪些职业可保？',
					answer:
						'本保单仅承保交通运输相关行业。本产品可保障职业：装卸工、司机、随车人员、文员、仓管等，需根据实际工作职业选择对应类别。',
				},
				{
					question: '中途是否可以加人？新增人员如何收费？',
					answer: '中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。',
				},
				{
					question: '如果从事高处作业，但是无安全带或者无特种作业操作证（比如高处作业证），保险公司是否拒赔？',
					answer:
						'不会拒赔。被保险人从业人员从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，免赔25%。',
				},
				{
					question: '什么是高处作业？',
					answer:
						'国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。”',
				},
				{
					question: '误工费怎么赔？',
					answer:
						'按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。被保险人雇员仅接受门诊治疗的，按本保单约定无误工费赔付。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer:
						'直接用电脑在此网页上操作即可，无需任何纸质资料，具体流程：选方案→填信息→支付保费→获取保单。目前支持微信、支付宝、银联支付。',
				},
				{
					question: '保单和发票怎么获取？',
					answer: '线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，如果选择专票则通过快递寄送。',
				},
				{
					question: '保单如何查验真伪？',
					answer: '可以通过拨打阳光财产保险全国客服电话95510进行人工查询。',
				},
				{
					question: '中途是否可以换人？',
					answer:
						'在保险有效期内，被替换的员工无出险的前提下，可以替换，无需缴纳保费。替换时，原装卸工、司机、随车人员只能替换为新的装卸工、司机、随车人员，原文员、仓管类人员只能替换为新的文员、仓管类人员。原货车司机、随车人员类人员只能替换为新的货车司机、随车人员。不分节假日，全天24小时，均可线上直接替换或新增人员。',
				},
				{
					question: '出险从业人员是否可替换出去？',
					answer: '不可以。',
				},
				{
					question: '怎么理赔？多久收到赔款？',
					answer:
						'出险后请拨打理赔专线400-180-1616报案→收集资料→提交审核→支付结案。万元以下案件资料齐全三个工作日赔款到账；万元以上案件纸质资料齐全，一般七个工作日赔款到账。',
				},
			],
		}
	},
	methods: {
		handleInsure() {
			this.$emit('insure')
		},
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (rowIndex < 6 || rowIndex == 14) {
				if (columnIndex == 0) {
					return [1, 2]
				}
				if (columnIndex == 1) {
					return [0, 0]
				}
			}

			if ((rowIndex > 2 && rowIndex < 6) || rowIndex == 14) {
				if (columnIndex == 2) {
					return [1, 3]
				}
			}

			if (rowIndex == 6 || rowIndex == 10) {
				if (columnIndex == 0) {
					return [4, 1]
				}
			}
			//
			if (rowIndex == 7 || rowIndex == 8 || rowIndex == 9 || rowIndex == 11 || rowIndex == 12 || rowIndex == 13) {
				if (columnIndex == 0) {
					return [0, 0]
				}
			}

			// if (rowIndex === 4) {
			//   if (columnIndex === 0) {
			//     return [1, 3]
			//   }
			// }
		},
		onCellStyle({row, column, rowIndex, columnIndex}) {
			if (rowIndex == 0) {
				return {
					color: 'rgba(0,0,0,.85)',
					background: '#fafafa',
					fontWeight: 'bold',
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}
</style>
